<template>
  <div>
    <el-row v-if="info.id == 0 || info.id == undefined">
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="info"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="直播类型">
        <el-radio-group v-model="info.live_type" @change="liveTypeChange">
          <el-radio :label="1" :disabled="info.id > 0 ? true : false">常规直播</el-radio>
          <el-radio :label="4" :disabled="info.id > 0 ? true : false">推流直播</el-radio>
          <el-radio :label="6" :disabled="info.id > 0 ? true : false">伪直播<strong style="color: red;">（伪直播开始时间必须在当前时间一小时后，并且距开始一小时内不能更新关联的视频，直播时长设置接近所选视频时长）</strong>
          </el-radio>

          <el-radio :label="7" :disabled="info.id > 0 ? true : false"><strong>小鹅通直播</strong></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="竖屏带货">
        <el-radio-group v-model="info.configuration.is_vertical_screen">
          <el-radio :label="0" :disabled="info.id > 0 ? true : false">否</el-radio>
          <el-radio :label="1" :disabled="info.id > 0 ? true : false">是 <strong style="color: red;">（选择是之后，竖屏带货直播，在H5不能观看回放，会引导在app观看)</strong></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="生活馆带货">
        <el-radio-group v-model="info.mall_live">
          <el-radio :label="0" :disabled="info.id > 0 ? true : false">否</el-radio>
          <el-radio :label="1" :disabled="info.id > 0 ? true : false">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="info.live_type == 6" :label="info.configuration.mock_course_period_type != 4 ? '视频' : '回放'">
        <el-input
            v-model="info.configuration.mock_course_period_title"
            placeholder="请选择"
            :disabled="true"
            style="width:80%"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          :disabled="info.id > 0 ? true : false"
          @click="
            search.chooseOrgVisible = true;
            searchData();
          "
        >
          查询
        </el-button>
      </el-form-item>

      <el-form-item label="分类">
        <el-select
          class="search-el"
          size="mini"
          v-model="info.course_category_id"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in categoryList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="标题">
        <el-input
          v-model="info.title"
          maxlength="30"
          show-word-limit
          style="width:33%"
        ></el-input>
      </el-form-item>
      <el-form-item label="副标题">
        <el-input
          v-model="info.intro"
          maxlength="30"
          show-word-limit
          style="width:33%"
        ></el-input>
      </el-form-item>
      <el-form-item label="封面">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="imageUploadOSSRequest"
          accept="image/*"
        >
          <img v-if="info.img_url" :src="info.img_url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb，封面大小 750x560
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="封面大图">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="imageUploadOSSRequest5"
          accept="image/*"
        >
          <img v-if="info.large_cover_image" :src="info.large_cover_image" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon3"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb，
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="海报">
        <el-upload
            class="avatar-uploader"
            :action="ossAction"
            :show-file-list="false"
            :http-request="imageUploadOSSRequest4"
            accept="image/*"
        >
          <img v-if="info.live_poster_url" :src="info.live_poster_url" class="avatar4" />
          <i v-else class="el-icon-plus avatar-uploader-icon4"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb，封面大小 750x1334
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="开课时间">
        <el-date-picker
          v-model="info.begin_day"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期">
        </el-date-picker>

        <el-time-picker
          is-range
          format = 'HH:mm' 
          value-format = 'HH:mm'
          v-model="info.begin_time"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围">
        </el-time-picker>
      </el-form-item>

      <el-form-item label="原价">
        <el-input type="number" v-model="info.price" style="width:33%"></el-input>
      </el-form-item>
      <el-form-item label="苹果原价">
        <el-input type="number" v-model="info.ios_price" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item label="是否优惠">
        <!-- <el-select
          class="search-el"
          v-model="info.is_discount"
          clearable
          placeholder="是否优惠"
        >
          <el-option :label="0" value='0'>没有优惠</el-option>
          <el-option :label="1" value="1">正常优惠</el-option>
        </el-select> -->
        <el-radio-group v-model="info.is_discount">
          <el-radio :label="0">没有优惠</el-radio>
          <el-radio :label="1">正常优惠</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="优惠价" v-if="info.is_discount == 1">
        <el-input type="number" v-model="info.discount_price" style="width:33%"></el-input>
      </el-form-item>
      <el-form-item label="苹果优惠价" v-if="info.is_discount == 1">
        <el-input type="number" v-model="info.ios_discount_price" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item label="限购人数">
        <el-input type="number" v-model="info.limit_user_num" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item label="讲师">
        <el-select
          class="search-el"
          v-model="info.teacher_id"
          placeholder="请选择或搜索讲师"
          clearable
          filterable
          @change="teacherChange"
        >
          <el-option
            v-for="item in teacherList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="详情" v-if="!info.configuration.is_vertical_screen">
        <tinymce v-model="info.detail" style="width:66%"></tinymce>
      </el-form-item>

      <el-form-item label="发布时间">
        <el-date-picker
          v-model="info.released_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择发布时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="分享海报">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="imageUploadOSSRequest2"
          accept="image/*"
        >
          <img v-if="info.share_url" :src="info.share_url" class="avatar3" />
          <i v-else class="el-icon-plus avatar-uploader-icon3"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb，尺寸 750x1050
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="客服姓名">
        <el-input v-model="info.course_counselor_name" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item label="客服二维码">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="imageUploadOSSRequest3"
          accept="image/*"
        >
          <img v-if="info.course_counselor_wechat_img" :src="info.course_counselor_wechat_img" class="avatar2" />
          <i v-else class="el-icon-plus avatar-uploader-icon2"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb，尺寸 240x170
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="会员免费">
        <el-radio-group v-model="info.level_id">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="2">免费</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="百家云虚拟人数">
        <el-input type="number" v-model="info.configuration.bjy_virtual_person_num" style="width:33%"></el-input>
      </el-form-item>
      <el-form-item label="灵动生活虚拟人数">
        <el-input type="number" v-model="info.virtual_study_number" style="width:33%"></el-input>
      </el-form-item>

      <el-form-item label="销售状态" v-if="!info.configuration.is_vertical_screen">
        <el-radio-group v-model="info.sale_status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">停售</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="前台展示">
        <el-radio-group v-model="info.show_flag">
          <el-radio :label="1">正常展示</el-radio>
          <el-radio :label="0">不展示</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="主讲区域" v-if="!info.configuration.is_vertical_screen">
        <el-checkbox v-model="info.configuration.detail" disabled>介绍</el-checkbox>
        <el-checkbox v-model="info.configuration.chat" disabled>聊天</el-checkbox>
        <el-checkbox v-model="info.configuration.faqs">问答</el-checkbox>
        <el-checkbox v-model="info.configuration.kejian">课件</el-checkbox>
      </el-form-item>

      <el-form-item label="直播间人数">
        <el-radio-group v-model="info.configuration.show_user_num">
          <el-radio :label="1">正常展示</el-radio>
          <el-radio :label="0">不展示</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="非会员看回放">
        <el-radio-group v-model="info.general_auth">
          <el-radio :label="0">不允许</el-radio>
          <el-radio :label="1">允许</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="伪直播消息来源" v-if="info.live_type == 6 && info.configuration.mock_course_period_type == 4">
        <el-radio-group v-model="info.configuration.mock_live_msg_source" :disabled="info.id > 0 ? true : false">
          <el-radio :label="0">回放原消息（不需要手动拉取，直播时百家云自动重放原直播聊天）</el-radio>
          <el-radio :label="1">手动拉取</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="createUpdate()"
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>

    <el-dialog
      title="选择"
      :visible.sync="search.chooseOrgVisible"
      :modal="false"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="mini"
            v-model="search.query.title"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            class="search-el"
            size="mini"
            v-model="search.query.is_vertical_screen"
            clearable
            placeholder="全部直播"
          >
            <el-option label="全部直播" value="0">全部直播</el-option>
            <el-option label="竖屏直播" value="1">竖屏直播</el-option>
            <el-option label="普通直播" value="2">普通直播</el-option>      
          </el-select>  
        </el-form-item>    
        <el-form-item>
          <el-button type="primary" size="mini" @click="searchData()">
            查询
          </el-button>
          <el-button type="primary" size="mini" @click="addPeriodVideo()">
            添加伪直播视频
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
        size="mini"
      >
        <el-table-column
          label="小节标题"
          align="center"
          min-width="20%"
        >
          <template slot-scope="{ row }">
            {{ "【小节ID： " + row.id + "】&nbsp;" + row.title }}
          </template>
        </el-table-column>

        <el-table-column
          label="主课"
          align="center"
          min-width="20%"
        >
          <template slot-scope="{ row }">
            <div v-if="row.course_type == 1">{{ "【线上课ID： " + row.course_id + "】&nbsp;" + row.course_title }}</div>
            <div v-else>{{ "【直播课ID： " + row.course_id + "】&nbsp;" + row.course_title }}</div>
          </template>
        </el-table-column>

        <el-table-column label="类别" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div v-if="row.type == 2">百家云点播视频</div>
            <div v-if="row.type == 4 && row.live_type == 1">常规直播回放</div>
            <div v-if="row.type == 4 && row.live_type == 4">推流直播回放</div>
            <div v-if="row.type == 4 && row.live_type == 6">伪直播回放</div>
          </template>
        </el-table-column>

        <el-table-column
          label="直播时间"
          align="center"
          min-width="12%"
          prop="begin_at"
        >
        </el-table-column>
        
        <el-table-column
          label="时长"
          align="center"
          min-width="10%"
        >
        <template slot-scope="{ row }">
            {{ durationShow(row.duration) }}
          </template>
        </el-table-column>

        <el-table-column
          label="回放/视频ID"
          align="center"
          min-width="12%"
          prop="bjy_video_id"
        >
        </el-table-column>

        <el-table-column
          label="竖屏直播"
          align="center"
          min-width="6%"
        >
        <template slot-scope="{ row }">
            {{ row.is_vertical_screen == '1' ? '是' : '否' }}
          </template>
        </el-table-column>
        
        <el-table-column label="操作" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import tinymce from "@/components/tinymce.vue";

import {
  imageUploadOSSRequest,
  getAliyunOssToken,
  getTeacherList,
  formatSeconds,
  formatDate,
  getCategoryList,
} from "@/api/common";

import { createUpdate, getDetail, searchBJYVideoList, createELive } from "@/api/live";

export default {
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      teacherList: [],
      categoryList: [],
      editor: null,
      info: {
        id: 0,
        period_id: 0,
        live_type: 1,
        title: "",
        intro: "",
        img_url: "",
        share_url: "",
        price: 0,
        ios_price: 0,
        is_discount: 0,
        discount_price: 0,
        ios_discount_price: 0,
        limit_user_num: 0,
        teacher_id : '',
        detail: "",
        released_at: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
        course_category_id: "",
        course_counselor_name: '',
        course_counselor_wechat_img: '',
        level_id: 0,
        virtual_study_number: 99,
        sale_status: 0,
        show_flag: 1,
        live_poster_url: '', //未直播海报
        large_cover_image: '', // 封面大图

        begin_day: formatDate(new Date(), 'yyyy-MM-dd'),
        begin_time: [formatDate(new Date(
          (new Date()).setMinutes(
            (new Date()).getMinutes() + 5
          )
        ), 'hh:mm'), "23:59"],
        configuration: {
          detail: true,
          chat: true,
          faqs: false,
          kejian: false,
          mock_course_period_id: 0,
          mock_course_period_type: 4,
          mock_course_period_title: '',
          mock_bjy_video_id: 0,
          is_vertical_screen: 0,//是否是竖屏直播，1-是，0-否
          virtual_study_number: 99,
          show_user_num: 1, //是否正常显示直播间人数，1-显示，0-隐藏
          mock_live_msg_source: 0, //伪直播消息来源，0-回放原消息（不需要手动拉取，直播时百家云自动重放原直播聊天），1-手动拉取
          bjy_virtual_person_num: 99, //百家云虚拟人数
        },

        general_auth: 0, //普通用户观看回放权限，0-不允许，1-允许
        mall_live: 0,
      },

      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          title: "",
          filterPeriodIds: [],
          page: 1,
          limit: 5,
          is_vertical_screen: ''
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  components: {
    tinymce,
  },
  created: function () {
    getTeacherList().then((response) => {
      this.teacherList = response.data;
    });
    getCategoryList({ type_code: "courselive" }).then((response) => {
      this.categoryList = response.data;
    });
    this.info.id = this.$route.query.id;
    this.info.period_id = this.$route.query.period_id;
    if (this.info.id > 0) {
      this.getInfo();
    }
  },
  mounted() {},
  methods: {
    teacherChange() {
      if (this.info.teacher_id == 2) {//卢老师时设置百家云虚拟人数为0
        this.info.configuration.bjy_virtual_person_num = 0;
      } else {
        this.info.configuration.bjy_virtual_person_num = 99;
      }
    },
    liveTypeChange() {
      if (this.info.live_type == 7) {
        this.$prompt("请输入小鹅通直播ID", "拉取小鹅通直播", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^l_[0-9a-zA-Z]{24}$/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          createELive({
            course_id: 0,
            resource_id: value,
          }).then((response) => {
            if (response.status == 2000) {  
              this.$message({
                showClose: true,
                message: response.message,
                type: "success",
                duration: 8 * 1000
              });
              this.$router.push({
                path: "/live/list",
              });
            } else {
              this.info.live_type = 1
            }
          });
        })
        .catch(() => {
          console.log('取消')
          this.info.live_type = 1
        });
      }
      else if (this.info.live_type == 6) {
        // this.info.begin_time = [formatDate(new Date(
        //   (new Date()).setHours(
        //     (new Date()).getHours() + 1,
        //     (new Date()).getMinutes() + 5
        //   )
        // ), 'hh:mm'), "23:59"]

        //伪直播开播时间默认19:30~21:00
        this.info.begin_time = ['19:30', "21:00"]
      } else {
        this.info.begin_time = [formatDate(new Date(
          (new Date()).setMinutes(
            (new Date()).getMinutes() + 5
          )
        ), 'hh:mm'), "23:59"]
      }
    },
    addPeriodVideo() { 
      if (window.location.host == 'dev.backend.zhangdefenspace.com') {
        window.open('http://dev.admin.defen.hzxinquanzi.com/?c=course&m=periodList&p=31&id=13601', '_blank');
      } else {
        window.open('http://admin.defen.hzxinquanzi.com/?c=course&m=periodList&p=31&id=13601', '_blank');
      }
    },
    selectProduct(row) {
      this.info.configuration.mock_course_period_id = row.id;
      this.info.configuration.mock_course_period_type = row.type;
      this.info.configuration.mock_course_period_title = row.title + ' 【时长：' + formatSeconds(row.duration) + '】' + ' 小节ID：' + row.id + ' 视频ID：' + row.bjy_video_id;
      this.info.configuration.mock_bjy_video_id = row.bjy_video_id;

      this.addEditFormOnClose();
    },
    durationShow(duration) {
      return formatSeconds(duration);
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.title = "";
      this.search.query.filterPeriodIds = [];

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      this.search.query.filterPeriodIds = this.search.query.filterPeriodIds.toString();
      searchBJYVideoList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },




    imageUploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        imageUploadOSSRequest(file.file, res.data, 500).then((fileUrl) => {
          this.info.img_url = fileUrl;
        });
      });
    },
    imageUploadOSSRequest2(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        imageUploadOSSRequest(file.file, res.data, 500).then((fileUrl) => {
          this.info.share_url = fileUrl;
        });
      });
    },
    imageUploadOSSRequest3(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        imageUploadOSSRequest(file.file, res.data, 500).then((fileUrl) => {
          this.info.course_counselor_wechat_img = fileUrl;
        });
      });
    },

    imageUploadOSSRequest4(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        imageUploadOSSRequest(file.file, res.data, 500).then((fileUrl) => {
          this.info.live_poster_url = fileUrl;
        });
      });
    },
    imageUploadOSSRequest5(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        imageUploadOSSRequest(file.file, res.data, 500).then((fileUrl) => {
          this.info.large_cover_image = fileUrl;
        });
      });
    },

    getInfo() {
      this.loading = true;
      getDetail({
        id: Number(this.info.id),
        period_id: Number(this.info.period_id),
      }).then((response) => {
        this.info = response.data;
        this.loading = false;
      });
    },
    createUpdate() {
      this.updateLoading = true;
      createUpdate(this.info)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/live/list",
              query: {
                type: this.info.type
              }
            });
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    ref() {
      window.history.go(-1);
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 112px;
  line-height: 112px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 112px;
  display: block;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}

.avatar-uploader-icon2 {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar2 {
  width: 100px;
  height: 100px;
  display: block;
}
.avatar-uploader-icon3 {
  font-size: 28px;
  color: #8c939d;
  width: 75px;
  height: 105px;
  line-height: 105px;
  text-align: center;
}
.avatar3 {
  width: 75px;
  height: 105px;
  display: block;
}
.avatar4 {
  width: 150px;
  height: 112px;
  display: block;
}
.avatar-uploader-icon4 {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 182px;
  line-height: 182px;
  text-align: center;
}
</style>